/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import AgentFormModal from './AgentFormModal';
import { TableCell, TableRow } from './ui/table';
import { Button } from './ui/button';
import LoanOfficerFormModal from './LoanOfficerFormModal';

interface Props {
  row: any;
}

const LoanOfficerTableRow: FC<Props> = ({ row }) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  return (
    <>
      <TableRow className="hover:bg-muted/30 cursor-pointer transition-colors">
        <>
          <TableCell className="py-3">
            {row.firstName} {row.lastName}
          </TableCell>
          <TableCell className="py-3">{row.emailAddress}</TableCell>
          <TableCell className="py-3">{row.phoneNumber ?? 'Unknown'}</TableCell>
          <TableCell className="py-3 flex justify-end">
            <Button
              onClick={() => setShowUpdateModal(true)}
              className="py-1 h-fit"
            >
              Edit Loan Officer
            </Button>
          </TableCell>
        </>
      </TableRow>
      <LoanOfficerFormModal
        agent={row}
        columns={['firstName', 'lastName', 'emailAddress', 'phoneNumber']}
        isOpen={showUpdateModal}
        setIsOpen={setShowUpdateModal}
      />
    </>
  );
};

export default LoanOfficerTableRow;
